/**
 * bem helper
 * b() // 'button'
 * b('text') // 'button__text'
 * b('text', 'color') // 'button__text button__text--color'
 * b({ disabled }) // 'button button--disabled'
 * b('text', { disabled }) // 'button__text button__text--disabled'
 * b(['primary', 'large']) // 'button button--primary button--large'
 */
var ELEMENT = '__';
var MODS = '--';

function join(name, el, symbol) {
  return el ? name + symbol + el : name;
}

function prefix(name, mods) {
  if (typeof mods === 'string') {
    return join(name, mods, MODS);
  }

  if (Array.isArray(mods)) {
    return mods.map(function (item) {
      return prefix(name, item);
    }).join(' ');
  }

  var ret = [];

  if (mods) {
    Object.keys(mods).forEach(function (key) {
      if (mods[key]) {
        ret.push(name + MODS + key);
      }
    });
  }

  return ret.join(' ');
}

export function createBEM(name) {
  return function (el, mods) {
    if (el && typeof el !== 'string') {
      mods = el;
      el = '';
    }

    el = join(name, el, ELEMENT);

    if (mods) {
      return (el + " " + prefix(el, mods)).trim();
    } else {
      return el;
    }
  };
}
export function addClass(base) {
  var result = base;

  for (var i = 0; i < (arguments.length <= 1 ? 0 : arguments.length - 1); i++) {
    var className = i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1];

    if (className) {
      if (Array.isArray(className)) {
        result = addClass(result, className);
      } else {
        result = result + " " + className;
      }
    }
  }

  return result;
}